import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import QualityModule from '@modules/Quality'

function QualityPage() {
  return <QualityModule />
}

export async function getStaticProps(ctx) {
  return {
    props: { ...(await serverSideTranslations(ctx.locale, ['common'])) },
  }
}

QualityPage.getLayout = QualityModule.getLayout

export default QualityPage
